module.exports = __webpack_public_path__ + "img/noa_opera.e9bc6e72.jpg";